"use strict";

exports.__esModule = true;
exports.AdvancedDataSourceField = AdvancedDataSourceField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AdvancedDataSourceField(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var defaultLabel = translate("AdvancedDataTableFields.advancedDataSource.label", "Advanced Data Source");
  var setProp = props.setProp,
    value = props.value,
    sources = props.sources,
    helperText = props.helperText,
    _props$label = props.label,
    label = _props$label === void 0 ? defaultLabel : _props$label;
  if (!value && sources && sources.length) {
    setProp(sources[0].value);
  }
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: label,
    helperText: helperText
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "AdvancedDataSourceField",
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: value,
    onChange: function onChange(e) {
      return setProp(e.target.value || undefined);
    }
  }, sources.map(function (source) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      "data-testid": "AdvancedDataSource." + source.value,
      key: source.value,
      value: source.value
    }, source.name);
  }))));
}